import Vue from 'vue'
import moment from 'moment'

moment.locale('sv')

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('D/M')
  }
})

Vue.filter('formatDateYear', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY')
  }
})

Vue.filter('formatDateDay', function(value) {
  if (value) {
    return moment(String(value)).format('ddd D/M')
  }
})

Vue.filter('formatDateHour', function(value) {
  if (value) {
    return moment(String(value)).format('LT - D/M')
  }
})
